import { withRouter } from 'react-router';
import { withUser } from 'components/queries/GetUserQuery';

import UpgradePointsCta from './UpgradePointsCta';

export default withRouter(withUser(UpgradePointsCta));
